// LoadingModal.tsx or inline usage
import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import BaseModal from './BaseModal';

type LoadingModalProps = {
  open: boolean;
};

const SimpleLoadingModal: React.FC<LoadingModalProps> = ({ open }) => {
  return (
    <BaseModal open={open} aria-labelledby="loading-modal">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <CircularProgress />
      </Box>
    </BaseModal>
  );
};

export { SimpleLoadingModal };
